<!-- =========================================================================================
  File Name: TodoDetailSidebar.vue
  Description: View Detail - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<i18n src="@/locales/modules/TodoListTranslate.json"></i18n>
<i18n src="@/locales/components/TimeRepeaterTranslate.json"></i18n>

<template>
	<div>
		<el-dialog class="custom-dialog todo-detail-dialog" append-to-body destroy-on-close :visible.sync="isSidebarActiveLocal">
			<div slot="title" class="flex justify-between items-center w-full">
				<span class="el-dialog__title break-normal">{{ $t("DetailTodo") }}</span>
				<todo-item-context-menu
					displayMode="detail"
					:todoItem="data"
					@onClickReject="data => $emit('onClickReject', data)"
					@onClickEdit="todoId => $emit('onClickEdit', todoId)"
					@onClickWatcher="data => $emit('onClickWatcher', data)"
					@onClickRecreate="todoId => $emit('onClickEdit', todoId)"
					@onClickCancel="todoId => $emit('onClickCancel', todoId)"
					@onClickReminder="todoId => $emit('onClickReminder', todoId)"
					@onClickAddDetail="data => $emit('onClickQuickConfigChildren', data)"
					@onClickCreateRequest="todoId => $emit('onClickCreateRequest', todoId)"
					@onClickToggleScheduleTodo="data => $emit('onClickToggleScheduleTodo', data)"
					@onClickSettingTimeRepeater="data => $emit('onClickSettingTimeRepeater', data)"
				/>
			</div>

			<cbs-comment-with-toggle :postId="dataId" :model="$constant.RELATION_MODELS.TODO" :key="`${dataId}-${isSidebarActiveLocal}`">
				<div class="body main__body">
					<!-- General Info -->
					<el-collapse v-model="activeGeneral" class="cbs-collapse mt-0">
						<el-collapse-item name="GeneralInfo">
							<template slot="title">
								<h6 class="uppercase font-bold ml-6">{{ $t("GeneralInfo") }}</h6>
							</template>
							<div class="p-6 pb-0">
								<div class="" v-if="data">
									<vs-row class="mb-1">
										<vs-col vs-w="4">
											<label class="text-solid-gray-1">{{ $t("Code") }}:</label>
										</vs-col>
										<vs-col vs-w="8" class="text-black">{{ data.code }}</vs-col>
									</vs-row>
									<vs-row class="mb-1">
										<vs-col vs-w="4">
											<label class="text-solid-gray-1">{{ $t("Name") }}:</label>
										</vs-col>
										<vs-col vs-w="8" class="text-black">{{ data.dataName }}</vs-col>
									</vs-row>
									<vs-row class="mb-1" v-if="data.parent">
										<vs-col vs-w="4">
											<label class="text-solid-gray-1">{{ $t("BelongTo") }}:</label>
										</vs-col>
										<vs-col vs-w="8">
											<router-link :to="{ query: { id: data.parent.id } }" class="underline text-black font-normal">{{ data.parent.name }}</router-link>
										</vs-col>
									</vs-row>
									<vs-row class="mb-1">
										<vs-col vs-w="4">
											<label class="text-solid-gray-1">{{ $t("Creator") }}:</label>
										</vs-col>
										<vs-col vs-w="8" class="text-black">
											<i class="nucleo nucleo-single-01-2" />
											{{ data.creater && data.creater.employee && data.creater.employee.display_name }}
										</vs-col>
									</vs-row>
									<vs-row class="mb-1">
										<vs-col vs-w="4">
											<label class="text-solid-gray-1">{{ $t("Employee") }}:</label>
										</vs-col>
										<vs-col vs-w="8" class="text-black">
											<div v-if="data.assignees">
												<display-relations class="flex flex-col" :relations="data.assignees" />
											</div>
										</vs-col>
									</vs-row>
									<vs-row class="mb-1">
										<vs-col vs-w="4">
											<label class="text-solid-gray-1">{{ $t("PriorityLevel") }}:</label>
										</vs-col>
										<vs-col vs-w="8">
											<div class="flex items-center h-full">
												<span>{{ $options.filters.filterPriority(data.properties, priorityMappedData) }}</span>
												<i
													:class="[
														{
															'nucleo-priority-S1': data.priority === 0,
															'nucleo-priority-S2 ml-2': data.priority === 1,
															'nucleo-priority-S3 ml-2': data.priority === 2,
															'nucleo-priority-S4 ml-2': data.priority === 3
														},
														'nucleo text-xl text-gray-3'
													]"
												/>
											</div>
										</vs-col>
									</vs-row>
									<vs-row class="mb-1">
										<vs-col vs-w="4">
											<label class="text-solid-gray-1">{{ $t("Status") }}:</label>
										</vs-col>
										<vs-col vs-w="8">
											<span v-if="data.type === $constant.TODO_TYPE.NORMAL" :class="[renderStatusColor(data.status_object.key), 'font-bold']">
												{{ data.status_object.value }}
											</span>
											<span v-else :class="['font-bold', data.readableProperties.schedule_enable ? 'text-primary' : 'text-danger']">
												{{ data.readableProperties.schedule_enable ? $t("Repeater.TurnedOn") : $t("Repeater.TurnedOff") }}
											</span>
										</vs-col>
									</vs-row>
									<vs-row class="mb-1" v-if="data.isCancel">
										<vs-col vs-w="4">
											<label class="text-solid-gray-1">{{ $t("ReasonCancel") }}:</label>
										</vs-col>
										<vs-col vs-w="8">
											<p class="text-black">
												{{ data.readableProperties && data.readableProperties.cancel_reason ? data.readableProperties.cancel_reason : "" }}
											</p>
										</vs-col>
									</vs-row>
									<vs-row class="mb-1">
										<vs-col vs-w="4">
											<label class="text-solid-gray-1">{{ $t("ReviewLevel") }}:</label>
										</vs-col>
										<vs-col vs-w="8">
											<div class="flex items-center h-full">
												<i :style="{fontSize: '3rem', cursor: 'pointer', color: checkReview(data.review, 1) ? '#F2994A' : '#828282'}" class="nucleo nucleo-priority-S1" v-on:click="changeReview(data, 1)"/>
												<i :style="{fontSize: '3rem', cursor: 'pointer', color: checkReview(data.review, 2) ? '#F2994A' : '#828282'}" class="nucleo nucleo-priority-S1" v-on:click="changeReview(data, 2)"/>
												<i :style="{fontSize: '3rem', cursor: 'pointer', color: checkReview(data.review, 3) ? '#F2994A' : '#828282'}" class="nucleo nucleo-priority-S1" v-on:click="changeReview(data, 3)"/>
												<i :style="{fontSize: '3rem', cursor: 'pointer', color: checkReview(data.review, 4) ? '#F2994A' : '#828282'}" class="nucleo nucleo-priority-S1" v-on:click="changeReview(data, 4)"/>
												<i :style="{fontSize: '3rem', cursor: 'pointer', color: checkReview(data.review, 5) ? '#F2994A' : '#828282'}" class="nucleo nucleo-priority-S1" v-on:click="changeReview(data, 5)"/>
											</div>
										</vs-col>
									</vs-row>
								</div>
							</div>
						</el-collapse-item>
					</el-collapse>

					<!-- Description Info -->
					<el-collapse class="cbs-collapse" v-if="data.description && data.description != ''">
						<el-collapse-item name="1">
							<template slot="title">
								<h6 class="uppercase font-bold ml-6">{{ $t("Description") }}</h6>
							</template>
							<div class="ql-editor p-6 pb-0" v-html="data.description"></div>
						</el-collapse-item>
					</el-collapse>

					<!-- Time Info -->
					<el-collapse v-model="activeGeneral" class="cbs-collapse" v-if="data.readableProperties && (data.readableProperties.start_date != '' || data.readableProperties.deadline != '')">
						<el-collapse-item name="TimeInfo">
							<template slot="title">
								<h6 class="uppercase font-bold ml-6">{{ $t("TimeInfo") }}</h6>
							</template>
							<div class="p-6 pb-0">
								<vs-row class="mb-1" v-if="data.readableProperties && data.readableProperties.start_date != ''">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1">{{ $t("StartDate") }}:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black">{{ data.readableProperties ? data.readableProperties.start_date : "" | dateTime(userDateTimeFormat) }}</vs-col>
								</vs-row>
								<vs-row v-if="data.readableProperties && data.readableProperties.deadline != ''">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1">{{ $t("Deadline") }}:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black">
										{{ data.readableProperties.deadline | dateTime(userDateTimeFormat) }}
									</vs-col>
								</vs-row>
							</div>
						</el-collapse-item>
					</el-collapse>

					<!-- Checklist -->
					<el-collapse class="cbs-collapse" v-if="totalChildrenTodoItem > 0">
						<el-collapse-item name="1">
							<template slot="title">
								<h6 class="uppercase font-bold ml-6">{{ `${$t("Checklist")} (${totalChildrenTodoItem})` }}</h6>
							</template>

							<div class="p-6 pb-0">
								<add-check-list
									v-if="data.todoitems && data.todoitems.data && data.todoitems.data.length"
									:title="''"
									:todoType="data.type"
									:parentTodoId="data.id"
									:defaultChecklist="data.todoitems.data"
									:disabledCheckDone="!data.can_complete"
									:canEdit="data.can_update && !data.isDone"
								/>

								<cbs-todo-check-list
									v-else
									isReadonly
									class="todo-check-list body__todo-check-list"
									:value="data.children"
									:inputPlaceholder="$t('Placeholder.InputTask')"
									@onClickTodoItem="handleNavigateToTodoDetail"
								>
									<template slot="context-menu" slot-scope="{ todoItem }">
										<todo-item-context-menu
											type="vertical"
											:todoItem="todoItem"
											@onSetStatusTodo="onClickStatus"
											@onClickReject="data => $emit('onClickReject', data)"
											@onClickEdit="todoId => $emit('onClickEdit', todoId)"
											@onClickWatcher="data => $emit('onClickWatcher', data)"
											@onClickRecreate="todoId => $emit('onClickEdit', todoId)"
											@onClickCancel="todoId => $emit('onClickCancel', todoId)"
											@onClickReminder="todoId => $emit('onClickReminder', todoId)"
											@onClickAddDetail="data => $emit('onClickQuickConfigChildren', data)"
											@onClickCreateRequest="todoId => $emit('onClickCreateRequest', todoId)"
											@onClickToggleScheduleTodo="data => $emit('onClickToggleScheduleTodo', data)"
											@onCompleteTodo="(todoItemId, statusKey) => handleCompleteTodo(todoItem, statusKey)"
										/>
									</template>

									<template slot="todo-item-readonly" slot-scope="{ todoItem }">
										<router-link
											event=""
											:class="['todo-check-list__item-readonly w-full block text-black font-normal truncate max-w-sm pl-3', { 'text-over-time': todoItem.is_over_due }]"
											:title="todoItem.name"
											:to="{ query: { id: todoItem.id } }"
											>{{ todoItem.name }}</router-link
										>
									</template>
								</cbs-todo-check-list>
							</div>
						</el-collapse-item>
					</el-collapse>

					<!-- Report Forms Config -->
					<el-collapse class="cbs-collapse" v-if="isShowReportFormsConfig">
						<el-collapse-item name="1">
							<template slot="title">
								<h6 class="uppercase font-bold ml-6">{{ $t("Report") }}</h6>
							</template>
							<div class="p-6 pb-0">
								<div class="report-form-content" v-for="reportForm in isSubmittedReportForms" :key="reportForm.id">
									<span class="text-base font-bold">{{ $t("Report") }} {{ reportForm.display_name }}</span>
									<dynamic-form-content :mappedAttachObj="mappedAttachFormObj[reportForm.id]" :value="getParsedReportFormsDataContent(reportForm).controls || []" />
								</div>
							</div>
						</el-collapse-item>
					</el-collapse>

					<!-- Time repeater -->
					<el-collapse class="cbs-collapse" v-if="data.type === $constant.TODO_TYPE.SCHEDULE">
						<el-collapse-item name="1">
							<template slot="title">
								<h6 class="uppercase font-bold ml-6">{{ $t("PeriodicTask") }}</h6>
							</template>
							<div class="p-6">
								<!-- Des -->
								<span v-if="data.readableProperties.schedule_repeat.dtstart">
									{{ $t("Since") }} {{ data.readableProperties.schedule_repeat.dtstart | dateTime(userDateTimeFormat) }}, {{ $t("RepeaterBy").toLowerCase() }}
									{{ data.readableProperties.schedule_repeat.interval }}
									{{ $t(`Repeater.${data.readableProperties.schedule_repeat.freq}`) }}
									1 {{ $t("Times") }}
								</span>
								<span v-else>
									{{ $t("RepeaterBy") }} {{ data.readableProperties.schedule_repeat.interval }}
									{{ $t(`Repeater.${data.readableProperties.schedule_repeat.freq}`).toLowerCase() }}
									1 {{ $t("Times") }}
								</span>
								<span
									v-if="
										data.readableProperties.schedule_repeat.byday &&
											splitStringToArray(data.readableProperties.schedule_repeat.byday).length > 0 &&
											data.readableProperties.schedule_repeat.freq === 'weekly'
									"
								>
									{{ $t("At") }}
									<span v-for="(item, key) in splitStringToArray(data.readableProperties.schedule_repeat.byday)" :key="key"
										>{{ $t(`DaysOfTheWeek.${item}`) }}<span v-if="key !== data.readableProperties.schedule_repeat.byday.length - 1">, </span></span
									>
								</span>
								<span
									v-if="
										data.readableProperties.schedule_repeat.byday &&
											typeof data.readableProperties.schedule_repeat.byday === 'string' &&
											(data.readableProperties.schedule_repeat.freq === 'yearly' || data.readableProperties.schedule_repeat.freq === 'monthly')
									"
								>
									{{ $t("At") }}
									<span v-for="(item, key) in data.readableProperties.schedule_repeat.byday.split(',')" :key="key"
										>{{ $t(`DaysOfTheWeek.${item}`) }}<span v-if="key !== data.readableProperties.schedule_repeat.byday.split(',').length - 1">, </span></span
									>
								</span>
								<span v-if="data.readableProperties.schedule_repeat.bysetpos && data.readableProperties.schedule_repeat.byday">
									&nbsp;({{ $t(`SetPos.${$options.filters.filterSetPos(data.readableProperties.schedule_repeat.bysetpos)}`) }})
								</span>
								<span v-if="data.readableProperties.schedule_repeat.bysetpos && data.readableProperties.schedule_repeat.byday && data.readableProperties.schedule_repeat.bymonth">
									&nbsp;{{ $t("Of") }} {{ $t(`${$options.filters.filterMonth(data.readableProperties.schedule_repeat.bymonth)}`).toLowerCase() }}
								</span>
								<span v-if="data.readableProperties.schedule_repeat.bymonthday && data.readableProperties.schedule_repeat.bymonth">
									{{ $t("At") }} {{ $t("Time.day") }} {{ data.readableProperties.schedule_repeat.bymonthday }}
									{{ $t(`${$options.filters.filterMonth(data.readableProperties.schedule_repeat.bymonth)}`).toLowerCase() }}
								</span>
								<span v-if="data.readableProperties.schedule_repeat.bymonthday && data.readableProperties.schedule_repeat.bymonth === null">
									{{ $t("At") }} {{ $t("Time.day") }} {{ data.readableProperties.schedule_repeat.bymonthday }}
								</span>
								<span
									v-if="
										splitStringToArray(data.readableProperties.schedule_repeat.byhour) &&
											splitStringToArray(data.readableProperties.schedule_repeat.byhour).length > 0 &&
											data.readableProperties.schedule_repeat.freq !== 'yearly' &&
											data.readableProperties.schedule_repeat.freq !== 'monthly' &&
											data.readableProperties.schedule_repeat.freq !== 'hourly'
									"
								>
									{{ $t("AtTime") }}
									<span v-for="(hour, inx) in splitStringToArray(data.readableProperties.schedule_repeat.byhour)" :key="hour"
										>{{ hour }}:00<span v-if="inx !== splitStringToArray(data.readableProperties.schedule_repeat.byhour).length - 1">, </span></span
									>
								</span>
								<span>.</span>
								<!-- End Des -->
							</div>
						</el-collapse-item>
					</el-collapse>

					<!-- Extra info -->
					<el-collapse
						class="cbs-collapse"
						v-if="(data.relations && data.relations.length > 0) || (data.watchers && data.watchers.length > 0) || (data.attachs && data.attachs.length > 0) || data.can_attach_files"
					>
						<el-collapse-item name="1">
							<template slot="title">
								<h6 class="uppercase font-bold ml-6">{{ $t("ExtraInfo") }}</h6>
							</template>
							<div class="p-6 pb-0">
								<!-- Relations or Device -->
								<vs-row class="mb-1" v-if="data.relations && data.relations.length > 0">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1">{{ categoryId === 1 ? $t("Device") : $t("Relations") }}:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black">
										<div v-if="data.relations">
											<display-relations class="flex flex-col" :relations="data.relations" />
										</div>
									</vs-col>
								</vs-row>

								<!-- Watchers -->
								<vs-row class="mb-1" v-if="data.watchers && data.watchers.length > 0">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1">{{ $t("Watcher") }}:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black">
										<div v-for="(watcher, index) in data.watchers" :key="`watcher${index}`">
											<div class="flex justify-start items-center" v-for="(relation, indexRelation) in watcher.relations" :key="`indexRelation${indexRelation}`">
												<display-item-relation :relation="relation" />
												<span v-if="watcher.reminded_at" class="ml-1">
													- {{ $t("RemindedAt") }}
													<span class="font-bold">{{ watcher.reminded_at | dateTime(userDateTimeFormat) }}</span>
												</span>
											</div>
										</div>
									</vs-col>
								</vs-row>
								<!-- Attachments -->
								<vs-row class="mb-1" v-if="(data.attachs && data.attachs.length > 0) || data.can_attach_files">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1">{{ $t("Attachments") }}:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black">
										<cbs-upload-ref v-if="data.attachs" :isEditable="data.can_attach_files" v-model="data.attachs" :key="dataId" />
									</vs-col>
								</vs-row>
							</div>
						</el-collapse-item>
					</el-collapse>

					<!-- Logs -->
					<el-collapse @change="toggleLogs" id="logs-with-loading" class="vs-con-loading__container cbs-collapse">
						<el-collapse-item name="1">
							<template slot="title">
								<h6 class="uppercase font-bold ml-6">{{ $t("Logs") }}</h6>
							</template>
							<div class="px-6 py-3" v-for="(log, index) in logs" :key="`logitem${index}`">
								<div class="flex flex-wrap justify-between">
									<h6 class="font-bold">{{ log.user.first_name }}</h6>
									<p>{{ log.created_at | dateTime(userDateTimeFormat) }}</p>
								</div>
								<p class="text-black">{{ log.content }}</p>
							</div>
							<h6 v-if="logs.length === 0" class="text-center px-6 py-3">{{ $t("Notify.NoDataAvailable") }}</h6>
						</el-collapse-item>
					</el-collapse>
				</div>
			</cbs-comment-with-toggle>

			<div class="flex justify-center flex-wrap" slot="footer" v-if="data && data.type !== $constant.TODO_TYPE.SCHEDULE && data.changable_statuses && data.changable_statuses.length">
				<vs-button
					v-for="(status, idx) in data.changable_statuses"
					:key="`status-${idx}`"
					:color="renderButtonColorByStatus(status.key)"
					:class="[
						'w-full sm:w-1/3 font-bold',
						{
							'mb-3 sm:mr-6 last:mr-0 last:mb-0': data && data.changable_statuses && data.changable_statuses.length > 1
						}
					]"
					@click.stop="onClickStatus(dataId, status.key)"
				>
					{{ status.value }}
				</vs-button>
			</div>
		</el-dialog>

		<todo-report-forms-dialog
			v-if="isShowReportFormsDialog"
			v-model="activeReportFormData"
			:reportFormsData="data.forms"
			:key="activeReportFormData.id"
			:isDialogActive="isShowReportFormsDialog"
			@onSubmit="handleSubmitReportForm"
			@closeDialog="toggleReportFormsDialog"
			@onClickStep="handleClickReportFormsStep"
		/>
	</div>
</template>

<script>
import _ from "lodash";
import moment from "moment";

import TodoItemContextMenu from "./TodoItemContextMenu.vue";
import CbsEditor from "@/components/cbs-editor/CbsEditor.vue";
import TodoReportFormsDialog from "./TodoReportFormsDialog.vue";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef.vue";
import AddCheckList from "@/components/add-check-list/AddCheckList.vue";
import CbsContextMenu from "@/components/cbs-context-menu/CbsContextMenu.vue";
import DisplayRelations from "@/components/display-relations/DisplayRelations.vue";
import CbsTodoCheckList from "@/components/cbs-todo-check-list/CbsTodoCheckList.vue";
import DynamicFormContent from "@/components/cbs-dynamic-form/DynamicFormContent.vue";
import DisplayItemRelation from "@/components/display-item-relation/DisplayItemRelation.vue";
import CbsCommentWithToggle from "@/components/cbs-comment-with-toggle/CbsCommentWithToggle.vue";

export default {
	components: {
		CbsEditor,
		AddCheckList,
		CbsUploadRef,
		CbsContextMenu,
		CbsTodoCheckList,
		DisplayRelations,
		DynamicFormContent,
		DisplayItemRelation,
		TodoItemContextMenu,
		CbsCommentWithToggle,
		TodoReportFormsDialog
	},
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		},
		categoryId: {
			type: Number
		}
	},
	emits: {
		editData: {},
		onClickEdit: {},
		closeSidebar: {},
		onClickCancel: {},
		onClickReject: {},
		onSubmitReport: {},
		onCompleteReport: {},
		onClickCreateRequest: {},
		onClickReminder: {}
	},
	watch: {
		data() {
			// this.getLogs(this.data.id);
			this.$forceUpdate();
		},
		"data.attachs": function(newAttachs, oldAttachs) {
			if (JSON.stringify(newAttachs) !== JSON.stringify(oldAttachs)) {
				const attachs = newAttachs ? newAttachs.map(file => Number(file.id)) : [];
				this.updateAttachsTodolist(attachs);
			}
		}
	},
	data() {
		return {
			logs: [],
			activeReportFormData: {},
			isShowReportFormsDialog: false,
			activeGeneral: ["GeneralInfo", "TimeInfo"],
			statusButtonColor: {
				0: "primary",
				1: "success",
				2: "danger",
				4: "primary",
				5: "success",
				7: "danger"
			},
			statusActions: {
				0: {},
				1: { function: "completeTodo" },
				2: { emits: "onClickCancel" },
				4: { emits: "onSetStatusTodo" },
				5: { emits: "onSetStatusTodo" },
				7: { emits: "onClickReject" }
			}
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},
		dataId() {
			return (this.data && this.data.id) || null;
		},
		isHasReportFormConfig() {
			return !!(this.data && this.data.forms && this.data.forms.length);
		},
		isShowReportFormsConfig() {
			return this.data && this.data.type !== this.$constant.TODO_TYPE.SCHEDULE && this.data.forms.some(form => !!form.is_submited);
		},
		isMultipleReportForms() {
			return this.data && this.data.forms && this.data.forms.length > 1;
		},
		lastIsSubmittedFormIndex() {
			return _.findLastIndex(this.data.forms, { is_submited: true });
		},
		activeReportFormIndex() {
			return _.findIndex(this.data.forms, { id: this.activeReportFormData.id });
		},
		isLastReportFormActive() {
			return this.activeReportFormIndex !== -1 && this.activeReportFormIndex === this.data.forms.length - 1;
		},
		mappedAttachFormObj() {
			const mappedAttachFormObj = {};
			(this.data.forms || []).forEach(form =>
				(form.attachs || []).forEach(attach => {
					mappedAttachFormObj[form.id] = mappedAttachFormObj[form.id] || {};
					mappedAttachFormObj[form.id][attach.id] = attach;
				})
			);
			return mappedAttachFormObj;
		},
		isSubmittedReportForms() {
			return (this.data.forms || []).filter(reportForm => !!reportForm.is_submited);
		},
		totalChildrenTodoItem() {
			return (this.data.todoitems && this.data.todoitems.data && this.data.todoitems.data.length) || (this.data.children && this.data.children.length) || 0;
		},
		priorityMappedData() {
			return {
				[this.$constant.TODO_ITEM_PRIORITY.LOW]: this.$t("Low"),
				[this.$constant.TODO_ITEM_PRIORITY.HIGH]: this.$t("High"),
				[this.$constant.TODO_ITEM_PRIORITY.MEDIUM]: this.$t("Medium"),
				[this.$constant.TODO_ITEM_PRIORITY.CRITICAL]: this.$t("Critical")
			};
		}
	},
	methods: {
		changeReview(data, num) {
			data.review = num;
			this.data.review = num;
			this.ratingTodo();
		},
		checkReview(review, num) {
			if (review) {
				return parseInt(review) >= num;
			}
			return false;
		},
		editData() {
			this.isSidebarActiveLocal = false;
			this.$emit("editData", this.dataId);
		},
		async ratingTodo() {
			if (this.isHasReportFormConfig) {
				this.toggleReportFormsDialog(true);
			} else {
				try {
					this.$vs.loading();
					await this.$store.dispatch("todoListManagement/ratingTodoItem", {
						id: this.dataId,
						review: this.data.review
					});
					// this.$emit("onCompleteReport", this.data.id);
					this.$helper.notifySuccess({
						context: this,
						options: {
							text: this.$t("RatingTodoSuccessful")
						}
					});
					// this.$emit("closeSidebar");
				} catch (error) {
					this.$helper.notifyError({ context: this, error });
				} finally {
					this.$vs.loading.close();
				}
			}
		},
		async completeTodo() {
			if (this.isHasReportFormConfig) {
				this.toggleReportFormsDialog(true);
			} else {
				try {
					this.$vs.loading();
					await this.$store.dispatch("todoListManagement/completeTodoItem", {
						id: this.dataId
					});
					this.$emit("onCompleteReport", this.data.id);
					this.$helper.notifySuccess({
						context: this,
						options: {
							text: this.$t("CompleteTodoSuccessful")
						}
					});
					// this.$emit("closeSidebar");
				} catch (error) {
					this.$helper.notifyError({ context: this, error });
				} finally {
					this.$vs.loading.close();
				}
			}
		},
		async getLogs(id) {
			this.$vs.loading({
				container: "#logs-with-loading",
				scale: 0.6
			});

			const dataTodoLogs = await this.$store.dispatch("todoListManagement/getTodoLogs", { relation_id: id });
			this.$vs.loading.close("#logs-with-loading > .con-vs-loading");

			if (dataTodoLogs && dataTodoLogs.logs) {
				this.logs = dataTodoLogs.logs;
			}
		},
		splitStringToArray(byday) {
			return _.split(byday, ",");
		},
		toggleReportFormsDialog(val = false) {
			this.isShowReportFormsDialog = val;
			if (!this.isShowReportFormsDialog) {
				this.activeReportFormData = {};
			} else {
				this.setInitActiveReportFormData();
			}
		},
		handleClickReportFormsStep(activeReportFormData) {
			this.setActiveReportFormData(activeReportFormData);
		},
		setInitActiveReportFormData() {
			if (this.isHasReportFormConfig) {
				let activeReportForm;
				if (this.lastIsSubmittedFormIndex >= 0) {
					activeReportForm =
						this.lastIsSubmittedFormIndex === this.data.forms.length - 1
							? this.data.forms[this.lastIsSubmittedFormIndex] // last report form is active
							: this.data.forms[this.lastIsSubmittedFormIndex + 1];
				} else {
					// not any form is submitted
					activeReportForm = this.data.forms[0];
				}
				this.setActiveReportFormData(activeReportForm);
			}
		},
		setActiveReportFormData(data) {
			this.activeReportFormData = this.$helper.formatDynamicFormData(_.cloneDeep(data), "properties", "data");
		},
		async handleSubmitReportForm() {
			try {
				this.$vs.loading();
				const mappedFormData = {};
				this.activeReportFormData.controls.forEach(field => {
					mappedFormData[field.id] = field.value;
					if (field.control === this.$constant.request.control.datetime && field.value) {
						// not format toISOString when type is time picker
						mappedFormData[field.id] = moment(field.value).isValid() ? moment(field.value).toISOString() : field.value;
					}

					if (!_.isEmpty(field.value) && field.control === this.$constant.request.control.relation && field.value.every(item => typeof item === "object")) {
						mappedFormData[field.id] = field.value.map(item => item.id);
					}
				});

				const payload = {
					formable_id: this.dataId,
					id: this.activeReportFormData.id,
					data: JSON.stringify(mappedFormData),
					formable_type: this.$constant.DYNAMIC_FORM_FIELD_MODELS.TODOLIST_REPORT_FORM
				};
				const response = await this.$store.dispatch("todoListManagement/submitReportFormTodoItem", payload);

				let notifyMessage = this.activeReportFormData.properties ? "UpdateReportFormTodoSuccessful" : "SendReportFormTodoSuccessful";
				if (this.isLastReportFormActive) {
					notifyMessage = "CompleteTodoSuccessful";
				}
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t(notifyMessage)
					}
				});
				this.$emit("onSubmitReport", response);
				if (!this.isMultipleReportForms || this.isLastReportFormActive) {
					// close dialog when complete all report forms
					this.$emit("onCompleteReport", this.data.id, response);
				} else if ((!this.isLastReportFormActive && this.data.forms[this.lastIsSubmittedFormIndex + 1]) || this.lastIsSubmittedFormIndex === -1) {
					// set active next report form
					const nextReportFormIndex = this.lastIsSubmittedFormIndex === -1 ? 1 : this.lastIsSubmittedFormIndex + 1;
					this.data.forms[nextReportFormIndex] && this.setActiveReportFormData(this.data.forms[nextReportFormIndex]);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		getParsedReportFormsDataContent(form) {
			return this.$helper.formatDynamicFormData(_.cloneDeep(form), "properties", "data") || {};
		},
		toggleLogs(ev) {
			if (ev.length > 0 && this.logs.length === 0) {
				this.getLogs(this.data.id);
			}
		},
		renderButtonColorByStatus(key) {
			return this.statusButtonColor[key];
		},
		onClickStatus(dataId, statusKey) {
			if (this.statusActions[statusKey].function) {
				this[this.statusActions[statusKey].function](dataId, statusKey);
			} else {
				this.$emit(this.statusActions[statusKey].emits, dataId, statusKey);
			}
		},

		handleNavigateToTodoDetail(todoItem) {
			this.$router.push({ name: this.$route.name, query: { ...this.$route.query, id: todoItem.id, is_child: true } });
		},
		handleCompleteTodo(todoItem, statusKey) {
			if (todoItem.forms && todoItem.forms.length > 0) {
				this.$vs.dialog({
					acceptText: this.$t("Actions.Close"),
					color: "primary",
					title: this.$t("Notifications"),
					text: this.$t("FillFormBeforeDone")
				});
			} else {
				this.$emit("onSetStatusTodo", todoItem.id, statusKey);
			}
		},
		async updateAttachsTodolist(attachsId) {
			this.$vs.loading();
			await this.$store.dispatch("todoListManagement/updateTodoItemAttachs", { id: this.dataId, attachs: attachsId });
			this.$vs.loading.close();
		}
	},
	filters: {
		filterPriority(todoItemProperties, priorityMappedData) {
			const parsedProperties = typeof todoItemProperties === "string" ? JSON.parse(todoItemProperties) : {};
			return priorityMappedData[parsedProperties.priority || 0];
		},
		filterSetPos(setPosVal) {
			switch (Number(setPosVal)) {
				case 1:
					return "First";
				case 2:
					return "Second";
				case 3:
					return "Third";
				case 4:
					return "Fourth";
				case -1:
					return "Last";
				default:
					return "";
			}
		},
		filterMonth(monthVal) {
			const monthObj = {
				1: "Jan",
				2: "Feb",
				3: "Mar",
				4: "Apr",
				5: "May",
				6: "Jun",
				7: "Jul",
				8: "Aug",
				9: "Sep",
				10: "Oct",
				11: "Nov",
				12: "Dec"
			};
			return monthObj[Number(monthVal)] || "";
		}
	},
	created() {
		this.setInitActiveReportFormData();
		console.log(this.data)
	}
};
</script>

<style lang="scss" scoped>
.todo-detail-dialog {
	.report-form-content {
		&:not(:last-child) {
			margin-bottom: 1.25rem;
			padding-bottom: 1.25rem;
			border-bottom: 1px solid var(--color-gray-6);
		}
	}

	.todo-check-list__item-readonly {
		height: 56px;
		line-height: 56px;
	}
}

#cancel-todo-dialog {
	::v-deep .el-dialog {
		width: 510px;
		max-width: unset;
	}
}
</style>
